import { useNavigate } from 'react-router';
import { AuthLayout } from '@/components/auth-layout';
import { ROUTES } from '@/shared/config/routes';
import { useLinkSignIn } from '../hooks/use-link-sign-in';
import { EmailSentView } from './email-sent-view';
import { LinkCheckingView } from './link-checking-view';
import { LinkExpiredView } from './link-expired-view';
import { LinkInvalidView } from './link-invalid-view';

/** Where the email link lands: sign in, or offer a fresh link when it expired. */
export function LinkSignInPanel() {
  const { state, showSent } = useLinkSignIn();
  const navigate = useNavigate();
  const viewKey = state.name === 'sent' ? `sent-${state.link.id}` : state.name;

  return (
    <AuthLayout viewKey={viewKey}>
      {state.name === 'checking' ? <LinkCheckingView /> : null}
      {state.name === 'invalid' ? <LinkInvalidView /> : null}
      {state.name === 'expired' ? (
        <LinkExpiredView link={state.link} onSent={(link) => showSent(link, false)} />
      ) : null}
      {state.name === 'sent' ? (
        <EmailSentView
          link={state.link}
          isResent={state.isResent}
          onResent={(link) => showSent(link, true)}
          onUseDifferentEmail={() => navigate(ROUTES.SIGN_IN)}
        />
      ) : null}
    </AuthLayout>
  );
}
